var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vmv-item"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.info),expression:"info"}],attrs:{"id":"textArea","rows":"4","maxlength":"5000","disabled":""},domProps:{"value":(_vm.info)},on:{"input":function($event){if($event.target.composing)return;_vm.info=$event.target.value}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }